<template>
  <div class="holidayguru">
    <CruiseCompassSearch
      :show-cooperation="showCooperation"
      :theme="theme"
    ></CruiseCompassSearch>
  </div>
</template>

<script>
import CruiseCompassSearch from "../components/search/CruiseCompassSearch.vue"

export default {
  components: {
    CruiseCompassSearch
  },
  props: {
    showCooperation: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: null
    }
  }
}
</script>
